import { useState } from "react";
import instructionsClose from "../../Assets/thank-you-order-details/instructions-close.svg";
import visitNowArrow from "../../Assets/thank-you-order-details/visit-now-arrow.svg";

const TncRedeemNoteBox = ({
  translation,
  productData,
  affiliateLink,
  issuedVouchers = [],
  variant,
}) => {
  const [openInst, setOpenInst] = useState(false);
  const [openRedeem, setOpenRedeem] = useState(false);
  const [openTermsCon, setOpenTermsCon] = useState(false);
  const [informationOpen, setInformationOpen] = useState(false);
  const [activeInformationTab, setActiveInformationTab] = useState("instructions");
  const normalizeUrl = (value) => {
    if (typeof value !== "string") return null;
    const url = value.trim();
    if (!url || ["null", "undefined"].includes(url.toLowerCase())) return null;

    try {
      const parsedUrl = new URL(url, window.location.origin);
      return ["http:", "https:"].includes(parsedUrl.protocol)
        ? parsedUrl.href
        : null;
    } catch {
      return null;
    }
  };
  const visitNowUrl =
    normalizeUrl(affiliateLink) ||
    normalizeUrl(productData?.data?.affiliateLink) ||
    normalizeUrl(issuedVouchers?.[0]?.RedemptionUrl?.Url);
  const openInformation = () => {
    setActiveInformationTab("instructions");
    setInformationOpen(true);
  };

  if (variant === "bom-actions") {
    return (
      <div className="tnc_redeem_note_box tnc_redeem_note_box--bom-actions">
        <button
          type="button"
          className="tnc-bom-actions__terms"
          aria-haspopup="dialog"
          onClick={() => setOpenTermsCon(true)}
        >
          {translation?.terms_condition}
        </button>
        <div className="tnc-bom-actions__buttons">
          <button
            type="button"
            className="tnc-bom-actions__instructions"
            aria-haspopup="dialog"
            onClick={openInformation}
          >
            {translation?.instructions_and_how_to_use}
          </button>
          {visitNowUrl && (
            <a
              className="tnc-bom-actions__visit"
              href={visitNowUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{translation?.visitNow}</span>
              <img src={visitNowArrow} alt="" />
            </a>
          )}
        </div>
        {openTermsCon && (
          <div
            className="tnc-bom-terms-dialog"
            role="dialog"
            aria-modal="true"
            aria-label={translation?.terms_condition}
            onClick={() => setOpenTermsCon(false)}
          >
            <section
              className="tnc-bom-terms-dialog__panel"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="tnc-bom-terms-dialog__handle" aria-hidden="true" />
              <header className="tnc-bom-terms-dialog__header">
                <h2>{translation?.terms_condition}</h2>
                <button
                  type="button"
                  className="tnc-bom-terms-dialog__close"
                  aria-label={translation?.close}
                  onClick={() => setOpenTermsCon(false)}
                >
                  <img src={instructionsClose} alt="" />
                </button>
              </header>
              <div
                className="tnc-bom-terms-dialog__body"
                dangerouslySetInnerHTML={{
                  __html: productData?.data?.tncContent || "",
                }}
              />
            </section>
          </div>
        )}
        {informationOpen && (
          <div
            className="tnc-bom-information-dialog"
            role="dialog"
            aria-modal="true"
            aria-label={translation?.instructions_and_how_to_use}
            onClick={() => setInformationOpen(false)}
          >
            <section
              className="tnc-bom-information-dialog__panel"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="tnc-bom-information-dialog__handle" aria-hidden="true" />
              <header className="tnc-bom-information-dialog__header">
                <div
                  className="tnc-bom-information-dialog__tabs"
                  role="tablist"
                >
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeInformationTab === "how-to-use"}
                    className={
                      activeInformationTab === "how-to-use" ? "is-active" : ""
                    }
                    onClick={() => setActiveInformationTab("how-to-use")}
                  >
                    {translation?.how_to_use}
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeInformationTab === "instructions"}
                    className={
                      activeInformationTab === "instructions" ? "is-active" : ""
                    }
                    onClick={() => setActiveInformationTab("instructions")}
                  >
                    {translation?.instructions}
                  </button>
                </div>
                <button
                  type="button"
                  className="tnc-bom-information-dialog__close"
                  aria-label={translation?.close}
                  onClick={() => setInformationOpen(false)}
                >
                  <img src={instructionsClose} alt="" />
                </button>
              </header>
              <div
                className="tnc-bom-information-dialog__body"
                role="tabpanel"
                dangerouslySetInnerHTML={{
                  __html:
                    activeInformationTab === "instructions"
                      ? productData?.data?.instructionsContent || ""
                      : productData?.data?.howToUseContent || "",
                }}
              />
            </section>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="tnc_redeem_note_box jlkkedit2 mt-3 mb-4">
      <div
        className="item tnc-item--instructions py-3"
        onClick={() => setOpenInst(!openInst)}
        style={{ cursor: "pointer" }}
      >
        <div className="text .jlkkedit2">{translation?.importantInstructions}</div>
        <div className="arrow">
          <i className={`fa-solid ${openInst ? "fa-angle-down" : "fa-angle-right"}`}></i>
        </div>
      </div>
      {openInst && (
        <div
          className="tnc-content tnc-content--instructions mt-2 mx-2 pd-left"
          style={{
            overflowWrap: "break-word",
          }}
          dangerouslySetInnerHTML={{
            __html: productData?.data?.instructionsContent || "",
          }}
        ></div>
      )}

      <div
        className="item tnc-item--redeem py-3"
        onClick={() => setOpenRedeem(!openRedeem)}
        style={{ cursor: "pointer" }}
      >
        <div className="text">{translation?.how_to_use}</div>
        <div className="arrow " onClick={() => setOpenRedeem(!openRedeem)}>
          <i className={`fa-solid ${openRedeem ? "fa-angle-down" : "fa-angle-right"}`}></i>
        </div>
      </div>
      {openRedeem && (
        <div
          className="tnc-content tnc-content--redeem mt-2 mx-2 pd-left"
          style={{
            overflowWrap: "break-word",
          }}
          dangerouslySetInnerHTML={{
            __html: productData?.data?.howToUseContent || "",
          }}
        ></div>
      )}

      <div
        className="item tnc-item--terms py-3"
        onClick={() => setOpenTermsCon(!openTermsCon)}
        style={{ cursor: "pointer" }}
      >
        <div className="text">{translation?.terms_condition}</div>
        <div className="arrow" onClick={() => setOpenTermsCon(!openTermsCon)}>
          <i className={`fa-solid ${openTermsCon ? "fa-angle-down" : "fa-angle-right"}`}></i>
        </div>
      </div>
      {openTermsCon && (
        <div
          className="tnc-content tnc-content--terms mt-2 mx-2 pd-left mb-2"
          style={{
            overflowWrap: "break-word",
          }}
          dangerouslySetInnerHTML={{
            __html: productData?.data?.tncContent || "",
          }}
        ></div>
      )}
    </div>
  );
};

export default TncRedeemNoteBox;
